export const conflictingSources: string[] = [
  'One manual explains hazard identification.',
  'Another document covers warehouse safety.',
  'A separate resource discusses industrial machinery.',
  'Another explains fire prevention.',
]

export const symptoms: string[] = [
  'And when you need materials about fall protection, electrical hazards, chemical exposure or occupational health...',
  'You’re searching all over again.',
]

export const needsIntro = 'Then your next training session arrives.'

export const needsList: string[] = [
  'You need a clear explanation.',
  'You need a professional diagram.',
  'You need realistic workplace examples.',
  'You need activities that make your students think.',
  'You need structured teaching resources.',
  'And you need a way to assess what they’ve learned.',
]

export const searchQuestions: string[] = [
  'What safety topic should I teach today?',
  'Where can I find complete, professional training materials?',
  'How can I explain industrial hazards more clearly?',
  'Where can I find high-quality safety illustrations?',
  'How do I demonstrate the difference between hazardous and improved workplace conditions?',
  'What realistic workplace scenarios can I use?',
  'How can I organize training for beginners and experienced learners?',
  'Where can I find practical hazard-identification exercises?',
  'How can I make technical topics easier to understand?',
  'How do I assess student knowledge?',
  'How can I prepare better training sessions without spending hours every week?',
]

export const painPoints: string[] = [
  'Hours spent searching for suitable industrial safety diagrams.',
  'Preparing every training session from scratch.',
  'Using scattered or incomplete safety resources.',
  'Trying to explain complex machinery hazards through long paragraphs.',
  'Searching different websites for workplace examples.',
  'Repeating the same activities because creating new ones takes too much time.',
  'Organizing disconnected documents and technical references.',
  'Struggling to demonstrate important safety concepts visually.',
  'Developing workplace hazard scenarios independently.',
  'Preparing knowledge assessments without a consistent structure.',
  'Losing valuable time that could be spent teaching.',
  'And constantly wondering whether you have enough quality material for your next training session.',
]

export const systemShows: string[] = [
  'WHAT TO TEACH.',
  'WHAT TO SHOW.',
  'HOW TO EXPLAIN IT.',
  'HOW TO ORGANIZE THE TRAINING.',
  'WHAT HAZARDS TO IDENTIFY.',
  'HOW TO ASSESS UNDERSTANDING.',
]
